import { ParamListBase, useFocusEffect } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { StackNavigationProp } from "@react-navigation/stack";
import { useCallback, useEffect, useState } from "react";
import { InteractionManager } from "react-native";

// return true when the interactions are done and the screen is ready to be rendered
export const useAfterInteractions = () => {
  const [ready, setReady] = useState(false);
  useFocusEffect(
    useCallback(() => {
      const task = InteractionManager.runAfterInteractions(() => {
        setReady(true);
      });
      return () => task.cancel();
    }, [])
  );
  return ready;
};

type NavigationType =
  | NativeStackNavigationProp<ParamListBase>
  | StackNavigationProp<ParamListBase>;

export function useHasTransitionEnded(navigation: NavigationType) {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    //@ts-ignore
    const unsubscribe = navigation.addListener("transitionEnd", () => {
      setReady(true);
    });
    return unsubscribe;
  }, [navigation]);
  return ready;
}
